import React from "react";
import { LuCircleCheck } from "react-icons/lu";
import styles from "./input-feedback.module.scss";

// Error text and character counter shown under TextInput / TextArea
export const InputFeedback: React.FC<{ id: string; errorText?: string; length: number; maxCharacters?: number; testId?: string }> = ({
  id,
  errorText,
  length,
  maxCharacters,
  testId,
}) => {
  if (!errorText && maxCharacters === undefined) return null;

  return (
    <div className={styles.inputFeedback}>
      {errorText && (
        <span id={id} className={styles.errorText} data-testid={testId && `${testId}-error`}>
          {errorText}
        </span>
      )}
      {maxCharacters !== undefined && (
        <span className={styles.charCount}>
          {length}/{maxCharacters}
        </span>
      )}
    </div>
  );
};

export const ValidIcon: React.FC<{ className?: string; testId?: string }> = ({ className, testId }) => (
  <LuCircleCheck size={14} className={`${styles.validIcon} ${className ?? ""}`} data-testid={testId && `${testId}-valid`} />
);
